import React from 'react';
import { Button } from '@clockout-dev/design-elements';
import { PlusCircleOutlined } from '@ant-design/icons';
import EmploymentTenureRuleRow from '../EmploymentTenureRuleRow';
import EmptyState from '../../../../../common/emptyState/EmptyState';
import styles from '../../styles/availableBalanceForm.module.scss';

function EmploymentTenurePanel({ rules = [], onAdd, onRemove, onUpdate }) {
    const showEmptyState = rules.length === 0;

    return (
        <div className={styles.panel}>
            {rules.map((rule) => (
                <EmploymentTenureRuleRow
                    key={rule.id}
                    rule={rule}
                    onUpdate={onUpdate}
                    onRemove={onRemove}
                />
            ))}
            {showEmptyState && (
                <EmptyState
                    title="No employment tenure rules yet"
                    description="Add a row to tailor the available balance by days employed at company."
                />
            )}
            <Button
                type="button"
                size="s"
                variant="text"
                className={styles.addRowButton}
                onClick={onAdd}
            >
                <PlusCircleOutlined />
                Add a user segment
            </Button>
        </div>
    );
}

export default EmploymentTenurePanel;
